import campaignBanner from './CampaignBanner';
import unconfirmedEmailBanner from './UnconfirmedEmailBanner';

export default {
    campaignBanner,
    unconfirmedEmailBanner,
};
